import { MouseEvent } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

type TimelineLayerMenuButtonProps = {
  title: string;
  open: boolean;
  onClick: (event: MouseEvent<HTMLElement>) => void;
};

export const TimelineLayerMenuButton = (
  props: TimelineLayerMenuButtonProps,
): JSX.Element => {
  const { title, open, onClick } = props;

  return (
    <ButtonBase
      aria-haspopup="true"
      aria-expanded={open}
      onClick={onClick}
      sx={{
        gap: 0.5,
        borderRadius: 1,
        backgroundColor: 'background.secondary',
        padding: 0.5,
        paddingLeft: 1.5,
        '&.Mui-focusVisible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2,
        },
      }}
    >
      {/* Span because a <p> isn't valid inside a <button> */}
      <Typography component="span" variant="body1" fontWeight={600}>
        {title}
      </Typography>
      <ArrowDropDownIcon />
    </ButtonBase>
  );
};
